module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAA8CAMAAADfciMYAAAAAXNSR0IB2cksfwAAAEVQTFRFAAAAIHj/IHb/H3b/H3b/H3b/H3b/IHD/Hnb/IHj/H3b/IHb/IHb/IHX/H3b/IHf/Hnb/H3b/IHX/IHX/HnX/Hnb/Hnf/N3scpgAAABd0Uk5TACBfr8//wBCPQO+AUGDgkKDQMD9vf58WjgPHAAAAqElEQVR4nO3SwQ7CIBAE0KIMSCnSovX/P1WtITJLY2pSTzJH9oVJFrqOog5HDYqhuT2hCgnXPw78oMojEgE4Oy5lMQDRdh+E6hHlnMWIqbqBRAJSDUoR1zpIaASeqcsz17cQJUnLjVmAADCZV3I5785WnVI48V71mYffWaz9A0//Y4uoKkX7v4l5Sfncbs65bdqpXzIKYXxOKPpKsff/aKKJJn4hOF+JOyH4D2nmnjfPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-alert--channels--facebook-active.png
// module id = 759
// module chunks = 0